export const PLAN = {
  customer: "Sophie R.",
  spa: "Aura Med Spa",
  area: "SoHo",
  request: "I need a hydrating facial and brow shaping tonight after 6, somewhere near SoHo.",
  services: [
    { name: "Hydrating Facial", provider: "Maya", time: "6:15 PM", mins: 60, price: 110, tone: "mint" },
    { name: "Brow Shaping", provider: "Lena", time: "7:20 PM", mins: 20, price: 55, tone: "lilac" },
  ],
  total: 165,
  window: "Tonight · after 6:00 PM",
};

export const TONE = {
  mint: { bg: "var(--mint)", fg: "#1F5C3A" },
  lilac: { bg: "var(--lilac)", fg: "#4B3A7A" },
  blush: { bg: "var(--blush)", fg: "var(--burgundy)" },
};
